module.exports = __webpack_public_path__ + "static/media/halluxguard-5.1978c29d.jpg";